import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { SplitText } from 'gsap/SplitText';
import { CustomEase } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText, CustomEase);

export { gsap, ScrollTrigger, ScrollToPlugin, SplitText, CustomEase };
